'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'clear',
    immutable: 'clear',
    object: function object() {
        return function () {
            return {};
        };
    },
    array: function array() {
        return function () {
            return [];
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/clear.js
// module id = 386
// module chunks = 35783957827783